/* prettier-ignore */
const leftNavCls = "_275l32xeny";
const listCls = "_275lfcmwul";

export { leftNavCls, listCls };
import "./root.left-nav.style.linaria.module.css";
//# sourceMappingURL=root.left-nav.style.js.map
